module.exports = __webpack_public_path__ + "static/media/donations.e4048eec.png";